import api from "../index";

// Signup user (auto-login)
export const signUp = async (name: any, email: any, password: any) => {
  return await api.post(
    "/signup",
    {
      name,
      email,
      password,
    },
    {
      withCredentials: true,
    }
  );
};

// Login user
export const login = async (email: any, password: any) => {
  return await api.post(
    "/login",
    {
      email,
      password,
    },
    {
      withCredentials: true,
    }
  );
};

// Google signup or login
export const googleCreateOrLogin = async (name: any, email: any) => {
  return await api.post(
    "/googleAuth",
    {
      name,
      email,
    },
    {
      withCredentials: true,
    }
  );
};

// Activate user account
export const accountActivate = async (token: any) => {
  return await api.post("/account/activate", {
    token,
  });
};

// Send reset user password email
export const resetPassword = async (email: any) => {
  return await api.post("/password/reset", {
    email,
  });
};

// Set new password
export const newPassword = async (token: any, newPassword: any) => {
  return await api.post("/password/reset/verify", {
    token,
    newPassword,
  });
};

// Account resend verification
export const resendVerification = async (email: any) => {
  return await api.post("/account/reverify", {
    email,
  });
};

// Verify OTP for email verification
export const verifyOTP = async (email: any, otp: any) => {
  return await api.post(
    "/verify-otp",
    {
      email,
      otp,
    },
    {
      withCredentials: true,
    }
  );
};

// Resend OTP for email verification
export const resendOTP = async (email: any) => {
  return await api.post("/resend-otp", {
    email,
  });
};

// Refresh access token
export const refreshAccessToken = async () => {
  return await api.post(
    "/refresh_token",
    {},
    {
      withCredentials: true,
    }
  );
};

// Log out user
export const logout = async () => {
  return await api.post(
    "/logout",
    {},
    {
      withCredentials: true,
    }
  );
};

// Captcha verify token
export const verifyCaptcha = async (token: any) => {
  return await api.post("/verify/captcha", {
    token,
  });
};

// AppSumo Signup user to send verification email
export const sumoSignUp = async (
  name: any,
  email: any,
  password: any,
  code: any
) => {
  return await api.post("/sumo/signup", {
    name,
    email,
    password,
    code,
  });
};

// AppSumo Select Signup user
export const sumoSelectSignUp = async (
  name: any,
  email: any,
  password: any,
  plan_id: any
) => {
  return await api.post("/sumo/select/signup", {
    name,
    email,
    password,
    plan_id,
  });
};
